module.exports = __webpack_public_path__ + "img/el-alquimista-cabanas_y_hoteles.c5e1a577.jpg";